module.exports = "<div class=\"input tableselect\">\r\n\t<label><%= property.get('description') %></label>\r\n \t<div class=\"tableSelectHolder\"></div>\r\n \t<input name=\"<%= property.id %>_text\" class=\"hiddenInputText\" type=\"hidden\" value=\"\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/report/templates/edit_report_saved_view/tableselect_view.template
// module id = 542
// module chunks = 51